/**
 * @author: lv.chen
 * @desc: Highlight今日核心要点组件
 * @date: 2025/12/15
 */
import React from 'react';
import classnames from 'classnames';
import { isEmpty, getSanitizeHTMLString } from '@intelligence/v3/utils/common';
import {
  CasualDailyReportData,
  CasualDailyReportsCorePointsClickAction,
} from '@intelligence/v3/pages/CasualDailyReports/utils';
import { reportButtonLog } from '@intelligence/v3/utils/logReporter';
import { dbiBtnLogMes } from '@intelligence/utils/buriedPointCfg';

interface ICasualDailyReportsHighlightProps extends IBaseProps {
  markdownConverter: React.MutableRefObject<CasualDailyReportData>;
  dom?: React.ReactNode;
  corePoints?: string;
}

const CasualDailyReportsHighlight: React.FC<ICasualDailyReportsHighlightProps> = (props) => {
  const { style, className, markdownConverter, dom, corePoints } = props;

  return (
    <div
      style={style}
      className={classnames('dbi-casual-daily-reports-highlight dbi-topic-highlight-section', className)}
    >
      <div className="dbi-topic-header">
        <div className="dbi-topic-title">今日核心要点</div>
        {React.isValidElement(dom) && dom}
      </div>
      <div className="dbi-topic-content">
        <div
          onClick={(e) => {
            e.stopPropagation();
            e.persist();
            const target = e?.target as HTMLElement;
            const dataset = target?.dataset;
            const clickAction = dataset?.clickAction;
            if (clickAction === CasualDailyReportsCorePointsClickAction.ViewReportDetails) {
              const extInfo = dbiBtnLogMes.casualDailyReportsClickCorePointsGRCReportLinker?.extInfo || '';
              const resourceId = dataset?.reportResourceId || '';
              reportButtonLog({
                ...dbiBtnLogMes.casualDailyReportsClickCorePointsGRCReportLinker,
                extInfo: isEmpty(resourceId) ? extInfo : `${extInfo}(${resourceId})`,
              });
            }
          }}
          dangerouslySetInnerHTML={{
            __html: markdownConverter.current.convertMarkdownToHTMLWithStyle(
              getSanitizeHTMLString(corePoints) || '',
              {
                h3: '',
                ul: '',
                li: '',
              },
              true,
            ),
          }}
        ></div>
      </div>
    </div>
  );
};

export default CasualDailyReportsHighlight;
